<template>
  <div class="not-found">
    <div class="not-found__topbar">
      <div>
        <Logo class="not-found__topbar--logo" />
      </div>
    </div>
    <div class="not-found__content">
      <h2 v-if="!isHebeMTClient">{{ $t('not_found.code') }}</h2>
      <span>{{ isHebeMTClient ? $t('not_found.title_hebe') : $t('not_found.title') }}</span>
      <span v-html="isHebeMTClient ? $t('not_found.content_hebe') : $t('not_found.content')" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import Logo from '@/assets/images/logo.svg';
import type { ComputedRef } from 'vue';

const isHebeMTClient: ComputedRef<boolean> = computed((): boolean =>
  window.location.href.includes('hebemt')
);
</script>
<style lang="scss" scoped>
.not-found {
  @apply relative;
  min-height: 100vh;
  min-height: 100svh;

  &__topbar {
    @apply flex items-center w-full relative border border-neutral-200;
    height: 84px;

    @include media-min($lg) {
      height: 95px;
    }

    &--logo {
      @apply my-0 mr-0 ml-6;
      max-width: 121px;

      @include media-min($lg) {
        @apply mr-8;
        max-width: 143px;
      }
    }
  }
  &__content {
    @apply w-full flex flex-col justify-center items-center text-center my-0 mx-auto py-14 px-5;
    max-width: 800px;

    @include media-min($lg) {
      @apply pt-24 px-0 pb-20;
    }
    h2 {
      @apply text-8xl m-0 font-bold;

      @include media-min($lg) {
        @apply text-9xl py-5;
      }
    }
    span {
      &:nth-of-type(1) {
        @apply uppercase py-5 px-0 text-xl;

        @include media-min($lg) {
          @apply text-3xl;
        }
      }
      &:nth-of-type(2) {
        @apply text-base;

        @include media-min($lg) {
          @apply text-xl;
        }
      }
    }
  }
}
</style>
